var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable } from 'mobx';
import { OrderCreate } from '../models/OrderCreateModel';
import { ReportsStore } from './ReportsStore';
import { ReportStore } from './ReportStore';
export class ClientViewStore {
    constructor(rootStore) {
        this.activeReportPackages = [];
        this.hideBackButton = false;
        this.loading = false;
        this.showHeaderMenu = false;
        this.invalidNationalId = false;
        this.createServerError = false;
        this.isExistingIndividual = false;
        this.companySpecificInvoicingRules = [];
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.loading = true;
            const companyId = (_a = this.rootStore.userStore.user) === null || _a === void 0 ? void 0 : _a.companyId;
            if (companyId) {
                this.loadCompanyDataById(companyId, true);
                if (this.activeReportPackages.length <= 0) {
                    this.loadActiveReportPackage(companyId);
                }
            }
            this.loading = false;
        });
        this.getCompanyInvoicingRules = (companyId) => __awaiter(this, void 0, void 0, function* () {
            yield this.network.getCompanyInvoicing(companyId).then(response => {
                let filteredResponse = response.filter(rule => !rule.key.startsWith("special."));
                if (response.find(rule => rule.key === "special.reference.person") !== undefined) {
                    this.invoiceReferencePersonRule = response.find(rule => rule.key === "special.reference.person");
                }
                else {
                    this.invoiceReferencePersonRule = null;
                }
                this.companySpecificInvoicingRules = filteredResponse !== undefined && filteredResponse !== null ? [...filteredResponse] : [];
            });
        });
        this.rootStore = rootStore;
        this.network = rootStore.network;
        this.reportStore = new ReportStore(this.rootStore);
    }
    loadActiveReportPackage(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const concernStructure = yield this.network.getConcernFlat(companyId);
            concernStructure === null || concernStructure === void 0 ? void 0 : concernStructure.map((company) => __awaiter(this, void 0, void 0, function* () {
                let activeReportPackages = yield this.network.getActiveCompanyReportPackages(company.id);
                if (activeReportPackages) {
                    this.activeReportPackages.push(...activeReportPackages);
                }
            }));
        });
    }
    //TODO: make smarter!
    loadCompanyDataById(companyId, subsidiaries) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.network
                .getCompanyDataById(companyId, subsidiaries, false)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                this.company = response;
            }))
                .catch(error => {
                console.error(error);
            });
            if ((_a = this.company) === null || _a === void 0 ? void 0 : _a.subsidiaries) {
                this.network
                    .getCompanyDataById(this.company.id, subsidiaries, true)
                    .then(response => {
                    response = response.sort(({ name: a }, { name: b }) => a < b ? -1 : a > b ? 1 : 0);
                    this.flatSubsidiaries = response;
                });
            }
        });
    }
    getCheckpointsByType(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.network.getCheckpointsByType(type);
            return response;
        });
    }
    getReportPackageBySubsidiaries(subsidiariesId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.activeReportPackages = [];
            this.activeReportPackages = yield this.network.getActiveCompanyReportPackages(subsidiariesId);
        });
    }
    onShowHeaderMenu() {
        this.showHeaderMenu = !this.showHeaderMenu;
    }
    getSubsidiariesCompany(subsidiariesId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.company) {
                if (subsidiariesId !== this.company.id) {
                    const subsidiariesCompany = yield this.network.getCompanyDataById(subsidiariesId, false, false);
                    this.company = subsidiariesCompany;
                }
            }
            else {
                const subsidiariesCompany = yield this.network.getCompanyDataById(subsidiariesId, false, false);
                this.company = subsidiariesCompany;
            }
            yield this.getCompanyInvoicingRules(subsidiariesId);
        });
    }
    setReportStore() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('<setReportStore>Is this used? From where?');
            this.loading = true;
            this.reportsStore = new ReportsStore(this.network, this.rootStore.userStore.user.companyId, this.rootStore.userStore.user.id);
            yield this.reportsStore.init();
            this.loading = false;
        });
    }
    hideModal() {
        this.modalOpen = false;
        this.init();
    }
    toggleModal() {
        this.modalOpen = !this.modalOpen;
    }
    resetNewOrder() {
        this.invalidNationalId = false;
        this.createServerError = false;
        this.isExistingIndividual = false;
    }
    buildCreateOrder(data, invoiceReferencePerson, invoiceSettings) {
        var _a, _b, _c, _d, _e;
        let stringDate = (_a = data.birthDate) === null || _a === void 0 ? void 0 : _a.value;
        const birthDate = new Date(stringDate);
        const nationalId = data.nationalId.value
            ? { country: 'SE', value: data.nationalId.value.replace(/\D/, '') }
            : { country: 'Other', value: birthDate.toISOString().split('T')[0] }; //pick the date part according to ISO 8601 (yyyy-MM-dd with .net notation)
        const individual = {
            nationalId,
            firstName: data.firstName.value,
            lastName: data.lastName.value,
            email: data.email.value,
            phoneNumber: data.phoneNumber.value
        };
        const educationOrder = data.educationinstitute
            ? [
                {
                    institute: (_b = data.educationinstitute) === null || _b === void 0 ? void 0 : _b.value,
                    course: (_c = data.educationdegree) === null || _c === void 0 ? void 0 : _c.value,
                    from: (_d = data.educationfromdate) === null || _d === void 0 ? void 0 : _d.value,
                    to: (_e = data.educationtodate) === null || _e === void 0 ? void 0 : _e.value
                }
            ]
            : null;
        const optionalCheckpoints = data.optionalCheckpoints.map(optionalCheckpoint => {
            return {
                checkpointId: optionalCheckpoint.checkpointId,
                isIncluded: optionalCheckpoint.isIncluded
            };
        });
        const internationalBackgroundCheckCountriesList = data.countriesBackgroundCheck
            ? this.listOfAllCountries(data.countriesBackgroundCheck, data.otherCountries)
            : [];
        const criminalRecordsList = data.criminalRecords
            ? this.listOfAllCountries(data.criminalRecords, data === null || data === void 0 ? void 0 : data.otherCriminalRecords)
            : [];
        const order = new OrderCreate({
            individual: individual,
            companyId: this.company.id,
            invoiceAddressId: data.address.items[data.address.selected].addressId,
            servicePackageId: this.selectedReportPackage.id,
            reportPackageId: this.selectedReportPackage.id,
            note: data.comments.value,
            customerInternalComment: data.customerInternalComment.value,
            invoiceReference: data.invoiceReference.value,
            fileIDs: data.fileIDs,
            additionalOrderRecipientUserId: data.additionalOrderRecipientUserId.value,
            checkpointOptions: optionalCheckpoints,
            educationOrderRequests: educationOrder,
            countriesBackgroundCheck: internationalBackgroundCheckCountriesList,
            criminalRecords: criminalRecordsList,
            referencePerson: this.invoiceReferencePersonRule === null ? null : invoiceReferencePerson,
            invoiceSettings: invoiceSettings
        });
        return order;
    }
    listOfAllCountries(countryList, otherCountryList) {
        var _a, _b;
        let countries = ((_a = countryList[0]) === null || _a === void 0 ? void 0 : _a.id) === '' ? [] : countryList;
        let otherCountries = ((_b = otherCountryList[0]) === null || _b === void 0 ? void 0 : _b.id) === '' ? [] : otherCountryList;
        return [...countries, ...otherCountries];
    }
    onClickGroupReport(grouporder) {
        return __awaiter(this, void 0, void 0, function* () {
            this.showGroupOrderWithGroupId = grouporder.id;
        });
    }
}
__decorate([
    observable
], ClientViewStore.prototype, "rootStore", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "selectedReportPackage", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "modalOpen", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "userModalOpen", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "activeReportPackages", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "hideBackButton", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "showGroupOrderWithGroupId", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "network", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "reportStore", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "reportsStore", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "company", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "flatSubsidiaries", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "loading", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "showHeaderMenu", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "invalidNationalId", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "createServerError", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "isExistingIndividual", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "invoiceReferencePersonRule", void 0);
__decorate([
    observable
], ClientViewStore.prototype, "companySpecificInvoicingRules", void 0);
__decorate([
    action
], ClientViewStore.prototype, "init", void 0);
__decorate([
    action
], ClientViewStore.prototype, "getCompanyInvoicingRules", void 0);
__decorate([
    action
], ClientViewStore.prototype, "getCheckpointsByType", null);
__decorate([
    action
], ClientViewStore.prototype, "getReportPackageBySubsidiaries", null);
__decorate([
    action
], ClientViewStore.prototype, "onShowHeaderMenu", null);
__decorate([
    action
], ClientViewStore.prototype, "getSubsidiariesCompany", null);
__decorate([
    action
], ClientViewStore.prototype, "setReportStore", null);
__decorate([
    action
], ClientViewStore.prototype, "hideModal", null);
__decorate([
    action
], ClientViewStore.prototype, "toggleModal", null);
__decorate([
    action
], ClientViewStore.prototype, "resetNewOrder", null);
__decorate([
    action
], ClientViewStore.prototype, "buildCreateOrder", null);
__decorate([
    action
], ClientViewStore.prototype, "listOfAllCountries", null);
__decorate([
    action
], ClientViewStore.prototype, "onClickGroupReport", null);
